// Rollbar transform (вынесен из main.js по той же причине, что rollbarIgnore:
// main.js не импортируется ни одним спеком). 2026-09-08.
//
// Инцидент (Rollbar f52f91d8): Android-клиент свернул приложение, устройство
// потеряло сеть, GET /notifications отвалился и после двух ретраев истёк по
// таймауту. Ошибка пришла UNCAUGHT (unhandled rejection → captureUnhandledRejections),
// а даунгрейд транзиентных сетевых ошибок до warning жил только в
// $reportError/setError — то есть на ЯВНОМ пути репортинга. Обычный офлайн
// мобильного клиента в результате лежал в проде как error.
//
// Здесь тот же критерий (isTransientNetworkError — обрыв/таймаут/отмена axios
// без ответа сервера) применяется ко всему, что доехало до Rollbar, включая
// uncaught. Уровни ниже error не трогаем: их ставят осознанно.
//
// 429 (лимит частоты, инцидент 2026-09-29) — туда же: setError его в Rollbar уже
// не шлёт, а прямой $reportError и uncaught доезжают сюда и тоже не дефект.
import { isTransientNetworkError, isRateLimitedError } from "@/utils/networkErrors";

const DOWNGRADABLE_LEVELS = ["error", "critical"];

// Сигнатура задана rollbar.js: options.transform(payload, item), где payload —
// data итема (мутируем на месте, его же уносит дальше по цепочке трансформов),
// а item.err — ИСХОДНЫЙ объект ошибки. Классифицировать по payload нельзя:
// признаки axios (isAxiosError/code/response) до payload не доезжают.
export function rollbarTransform(payload, item) {
  try {
    if (!payload || !item) return;
    if (DOWNGRADABLE_LEVELS.indexOf(payload.level) === -1) return;
    if (!isTransientNetworkError(item.err) && !isRateLimitedError(item.err)) return;
    payload.level = "warning";
  } catch (e) {
    // При любой осечке — оставить как было: потерять уровень лучше, чем отправку.
  }
}
